import { Alert, Slide, SlideProps, Snackbar } from '@mui/material';
import { AlertType } from '../../types/AlertType';
import { ComponentType } from 'react';
const vertical = "bottom";
const horizontal = "right";

type TransitionProps = Omit<SlideProps, 'direction'>;

function TransitionRight(props: TransitionProps) {
  return <Slide {...props} direction="left" />;
}

export const SnackBarAlert = (open: boolean, handleClose: () => void, alertType: AlertType = "success", message?: string, isLogDuration?: boolean): JSX.Element => {
  const transition: ComponentType<TransitionProps> = TransitionRight;
  let duree = 5000;

  if (alertType === "error" && !message) {
    message = "Une erreur est survenue, Veuillez reéssayez !"
  }

  if (isLogDuration === true) {
    duree = 10000;
  }

  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical, horizontal }}
      TransitionComponent={transition}
      autoHideDuration={duree}
      onClose={handleClose}>
      <Alert onClose={handleClose} severity={alertType} sx={{ width: '100%' }}>
        {message?.split('<br/>').map((line) => (
          <p key={line}>{line}</p>
        ))}
      </Alert>
    </Snackbar>
  );
};